export default "__VITE_ASSET__DXmUDfHw__"